import {combineReducers} from 'redux';
import usersReducer from './usersReducer';
import authReducer from './authReducer';
import flowReducer from './flowReducer';
import additionalHealthReducer from './additionalHealthReducer';
import beneficiariesReducer from './beneficiariesReducer';
import api from '../api';
import {abflagsReducer} from './abflagsReducer';

const rootReducer = combineReducers({
    api: api.reducer,
    users: usersReducer,
    auth: authReducer,
    flow: flowReducer,
    additionalHealth: additionalHealthReducer,
    beneficiaries: beneficiariesReducer,
    abflags: abflagsReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export default rootReducer;
